import { styled } from '@mui/material/styles'
import { ImageProps } from 'next/image'
import { shadows } from 'styles/colors'

import Image from './ImageWrapper'

const ImageWrap = styled('div')`
  & > span {
    filter: drop-shadow(${shadows.image});
  }
`

interface Props extends ImageProps {
  alt?: string
}

/**
 *
 * @description A wrapper with drop-shadow for Next.js's Image component.
 * @param {Props} props
 */
const PhoneImage = ({ alt, ...props }: Props) => (
  <ImageWrap>
    <Image alt={alt} width="260px" height="540px" {...props} />
  </ImageWrap>
)

export default PhoneImage
